<!-- NAVBAR -->
<a class="navbar-brand" href="/">Go home page</a>


<!-- TESTIMONIALS -->
<section id="testimonials" class="section testimonials">
  <div class="container">
    
    <div class="row justify-content-center mt-5">
      <div class="col-lg-7">

        <div class="testimonial-form-box">

          <h3>
            Share your experience
          </h3>

          <p>
            Your testimonial helps other families make confident decisions about their future.
          </p>

          <form
            #testimonialForm="ngForm"
            (ngSubmit)="sendTestimonial(testimonialForm)"
          >

            <input
              type="text"
              class="form-control"
              placeholder="Full name"
              [(ngModel)]="testimonialData.name"
              name="testimonialName"
              required
            >

            <input
              type="text"
              class="form-control"
              placeholder="Location"
              [(ngModel)]="testimonialData.location"
              name="testimonialLocation"
              required
            >

            <select
              class="form-control"
              [(ngModel)]="testimonialData.rating"
              name="testimonialRating"
              required
            >
              <option [ngValue]="5">5 Stars</option>
              <option [ngValue]="4">4 Stars</option>
              <option [ngValue]="3">3 Stars</option>
              <option [ngValue]="2">2 Stars</option>
              <option [ngValue]="1">1 Star</option>
            </select>

            <textarea
              rows="5"
              class="form-control"
              placeholder="Write your testimonial"
              [(ngModel)]="testimonialData.message"
              name="testimonialMessage"
              required
            ></textarea>

            <button
              type="submit"
              class="btn-main w-100"
              [disabled]="isSendingTestimonial || testimonialForm.invalid"
            >

              @if (!isSendingTestimonial) {

                <span>
                  Send testimonial
                  <i class="bi bi-send-fill"></i>
                </span>

              } @else {

                <span class="d-flex justify-content-center align-items-center gap-2">
                  <span class="spinner-border spinner-border-sm"></span>
                  Sending...
                </span>

              }

            </button>

          </form>

        </div>

      </div>
    </div>


  </div>
</section>